<section class="page">
  <div class="page__content">
    <div class="page__text">
      <h1 class="page__title">
        <span
          class="page__title-accent"
          [innerHTML]="'investments.title' | translate"
        ></span>
        <span class="page__title-main"
          >{{ 'investments.subtitle' | translate }}</span
        >
      </h1>
      <p class="page__description">
        {{ 'investments.description' | translate }}
      </p>
      <button
        kendoButton
        themeColor="primary"
        size="large"
        class="page__action"
        maximizerShowcaseBookDemo
      >
        {{ 'investments.button.action' | translate }}
      </button>
    </div>
    <div class="page__media">
      <img
        [src]="cdn + '/assets/images/showcase/investment.svg'"
        [alt]="'investments.image.alt' | translate"
        class="page__image"
      />
    </div>
  </div>
</section>
